<template>
    <div>
        <v-row :class="isMobile == true ? 'no-pd' : ''">
            <v-col cols="12" sm="6" md="4">
                <h1 class="headline font-weight-light mb-3">
                    {{ "OT - " + data_main.paycode }}
                </h1>
            </v-col>
            <v-spacer></v-spacer>

            <v-col cols="12" sm="6" md="8" class="text-right">
                <v-btn
                    small
                    color="white"
                    class="mr-5 primary--text"
                    rounded
                    v-if="data_main.approve_status != null"
                    @click="dialogLogOT = true"
                >
                    <v-icon left small>mdi-magnify</v-icon>
                    View Approve Log
                </v-btn>

                <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    offset-x
                    v-if="chk_approve == 'not approve' && chk_calculate == true"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            small
                            color="amber"
                            dark
                            v-bind="attrs"
                            v-on="on"
                        >
                            {{ "Request OT : " + checkboxs.length + " Cases" }}
                        </v-btn>
                    </template>

                    <v-card>
                        <v-list>
                            <v-list-item>
                                <v-text-field
                                    small
                                    label="หมายเหตุการแก้ไข..."
                                    v-model="form_save.remark"
                                ></v-text-field>
                            </v-list-item>
                        </v-list>

                        <v-card-actions>
                            <v-btn small text @click="close_approve()"
                                >Cancel</v-btn
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                small
                                color="success"
                                :disabled="form_save.remark.length <= 0"
                                @click="save()"
                                >Save</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-menu>

                <v-btn
                    v-if="
                        data_main.approve_status === null &&
                            showbtn == 'Y' &&
                            chk_calculate == true
                    "
                    :color="
                        data_main.approve_status === null
                            ? 'success'
                            : 'yellow darken-2'
                    "
                    small
                    @click="save()"
                    :disabled="checkboxs.length == 0"
                    rounded
                >
                    <v-icon small class="mr-1">mdi-content-save</v-icon>
                    {{ "Request OT : " + checkboxs.length + " Cases" }}</v-btn
                >

                <v-btn-toggle
                    rounded
                    v-if="
                        chk_approve != 'not approve' &&
                            data_main.approve_status != null
                    "
                >
                    <v-tooltip top>
                        <template
                            v-slot:activator="{
                                on,
                            }"
                        >
                            <v-btn
                                small
                                v-on="on"
                                :color="
                                    data_main.approve_status
                                        .requested_status === null
                                        ? 'blue-grey darken-2'
                                        : 'green accent-3 white--text'
                                "
                            >
                                CE
                            </v-btn>
                        </template>
                        <span>{{
                            data_main.approve_status.requested_date
                        }}</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <template
                            v-slot:activator="{
                                on,
                            }"
                        >
                            <v-btn
                                small
                                v-on="on"
                                :color="
                                    chk_approve_color(
                                        data_main.approve_status
                                            .requested_status,
                                        1,
                                        data_main.approve_status.head_status
                                    )
                                "
                            >
                                TL
                            </v-btn>
                        </template>
                        <span>{{ data_main.approve_status.head_date }}</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <template
                            v-slot:activator="{
                                on,
                            }"
                        >
                            <v-btn
                                v-on="on"
                                small
                                :color="
                                    chk_approve_color(
                                        data_main.approve_status
                                            .requested_status,
                                        2,
                                        data_main.approve_status.mgr_status
                                    )
                                "
                            >
                                MGR
                            </v-btn>
                        </template>
                        <span>{{ data_main.approve_status.mgr_date }}</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <template
                            v-slot:activator="{
                                on,
                            }"
                        >
                            <v-btn
                                v-on="on"
                                small
                                :color="
                                    chk_approve_color(
                                        data_main.approve_status
                                            .requested_status,
                                        3,
                                        data_main.approve_status.md_status
                                    )
                                "
                            >
                                MD
                            </v-btn>
                        </template>
                        <span>{{ data_main.approve_status.md_date }}</span>
                    </v-tooltip>
                </v-btn-toggle>
                <br v-if="chk_approve === 'not approve'" />
                <br v-if="chk_approve === 'not approve'" />
                <span class="red--text" v-if="chk_approve === 'not approve'"
                    >**{{ text_show }}</span
                >
            </v-col>
        </v-row>

        <v-card :class="isMobile == true ? 'no-pd' : ''">
            <v-row
                style="background-color:#0c374e"
                class="mb-5"
                v-if="
                    chk_approve != 'not approve' &&
                        data_main.approve_status != null
                "
            >
                <v-col cols="12" class="text-right">
                    <span class="ml-5 mr-2 amber--text"
                        ><b>Summary OT (Hrs.)</b></span
                    >
                    <v-btn-toggle rounded>
                        <v-tooltip top>
                            <template
                                v-slot:activator="{
                                    on,
                                }"
                            >
                                <v-btn
                                    small
                                    v-on="on"
                                    :color="
                                        data_main.sum.x10 != 0
                                            ? 'green accent-3'
                                            : 'grey lighten-1'
                                    "
                                >
                                    x1.0 :
                                    {{ data_main.sum.x10 }}
                                </v-btn>
                            </template>
                            <span>x1.0</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <template
                                v-slot:activator="{
                                    on,
                                }"
                            >
                                <v-btn
                                    small
                                    v-on="on"
                                    :color="
                                        data_main.sum.x15 != 0
                                            ? 'green accent-3'
                                            : 'grey lighten-1'
                                    "
                                >
                                    x1.5 :
                                    {{ data_main.sum.x15 }}
                                </v-btn>
                            </template>
                            <span>x1.5</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <template
                                v-slot:activator="{
                                    on,
                                }"
                            >
                                <v-btn
                                    small
                                    v-on="on"
                                    :color="
                                        data_main.sum.x30 != 0
                                            ? 'green accent-3'
                                            : 'grey lighten-1'
                                    "
                                >
                                    x3.0 :
                                    {{ data_main.sum.x30 }}
                                </v-btn>
                            </template>
                            <span>x3.0</span>
                        </v-tooltip>
                    </v-btn-toggle>
                </v-col>
            </v-row>
            <v-row style="background-color:#0c374e" class="mb-5" v-else>
                <v-col
                    cols="12"
                    v-if="chk_calculate == false"
                    class="text-right"
                >
                    <v-progress-linear
                        v-if="chk_load == true"
                        indeterminate
                        color="orange accent-4"
                    ></v-progress-linear>
                    <v-btn
                        v-if="chk_load == false"
                        small
                        rounded
                        color="amber"
                        @click="calculate()"
                        :disabled="checkboxs.length == 0"
                    >
                        <v-icon class="mr-1">mdi-webhook</v-icon>
                        <span :class="checkboxs.length == 0 ? 'blue--text' : ''"
                            >calculate ot</span
                        >
                    </v-btn>
                </v-col>
                <v-col
                    cols="12"
                    v-if="chk_calculate == true"
                    class="text-right"
                >
                    <span class="ml-5 mr-2 amber--text"
                        ><b>Summary OT (Hrs.)</b></span
                    >
                    <v-btn-toggle rounded>
                        <v-tooltip top>
                            <template
                                v-slot:activator="{
                                    on,
                                }"
                            >
                                <v-btn
                                    small
                                    v-on="on"
                                    :color="
                                        data_main.sum.x10 != 0
                                            ? 'green accent-3'
                                            : 'grey lighten-1'
                                    "
                                >
                                    x1.0 :
                                    {{ data_main.sum.x10 }}
                                </v-btn>
                            </template>
                            <span>x1.0</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <template
                                v-slot:activator="{
                                    on,
                                }"
                            >
                                <v-btn
                                    small
                                    v-on="on"
                                    :color="
                                        data_main.sum.x15 != 0
                                            ? 'green accent-3'
                                            : 'grey lighten-1'
                                    "
                                >
                                    x1.5 :
                                    {{ data_main.sum.x15 }}
                                </v-btn>
                            </template>
                            <span>x1.5</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <template
                                v-slot:activator="{
                                    on,
                                }"
                            >
                                <v-btn
                                    small
                                    v-on="on"
                                    :color="
                                        data_main.sum.x30 != 0
                                            ? 'green accent-3'
                                            : 'grey lighten-1'
                                    "
                                >
                                    x3.0 :
                                    {{ data_main.sum.x30 }}
                                </v-btn>
                            </template>
                            <span>x3.0</span>
                        </v-tooltip>
                    </v-btn-toggle>
                </v-col>
            </v-row>
            <v-row v-for="(row, index) in data_main.detail" :key="index">
                <v-col cols="12" md="6">
                    <v-chip small class="ml-2" color="primary">{{
                        row.date + " - " + row.onsite_date_dw
                    }}</v-chip>

                    <v-chip
                        v-if="row.date_type == 'weekend'"
                        small
                        color="red accent-2 white--text"
                        class=" ml-2 mr-2"
                        >เสาร์อาทิตย์</v-chip
                    >
                    <v-chip
                        v-if="row.date_type == 'holiday'"
                        small
                        color="amber"
                        >วันหยุด</v-chip
                    >
                    <v-chip small class="green accent-3  ml-2">
                        {{ row.total_date }}
                    </v-chip>
                </v-col>
                <v-spacer></v-spacer>

                <v-col cols="12" class="mar-t-30">
                    <v-col cols="12">
                        <v-simple-table class="table-inv">
                            <template v-slot:default>
                                <thead>
                                    <tr class="col-tr-1">
                                        <th class="text-center">
                                            #
                                        </th>

                                        <th class="text-center">
                                            Site
                                        </th>
                                        <th class="text-center">
                                            Case Title
                                        </th>

                                        <th class="text-center">
                                            Rate Overtime (Hrs.)
                                        </th>
                                        <!-- <th class="text-center">
                                            GPS
                                        </th> -->
                                        <th class="text-center"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(r, i) in row.case" :key="i">
                                        <td>{{ i + 1 }}.</td>

                                        <td>
                                            <v-btn
                                                class="mt-1 mb-1 mr-1"
                                                :to="
                                                    '/Project/ViewCasepending/' +
                                                        team_name +
                                                        '/' +
                                                        r.maincase_id +
                                                        '/ViewDetail'
                                                "
                                                target="_blank"
                                                small
                                                color="white"
                                                rounded
                                                v-if="r.case_type"
                                            >
                                                <span class="primary--text mr-1"
                                                    >{{
                                                        r.case_id +
                                                            "-" +
                                                            r.subcase
                                                    }}
                                                </span>

                                                <span class="teal--text">
                                                    {{ r.created_date }}</span
                                                >
                                            </v-btn>

                                            <v-chip
                                                small
                                                :color="
                                                    r.case_type == 'bench'
                                                        ? 'red lighten-1'
                                                        : ''
                                                "
                                                class="mt-1 mb-1 mr-1"
                                                >{{ r.case_type }}</v-chip
                                            >

                                            <v-chip
                                                small
                                                class="mt-1 mb-1 mr-1"
                                                >{{ r.project_name }}</v-chip
                                            >
                                            <v-chip
                                                class="mt-1 mb-1"
                                                small
                                                :color="r.colors"
                                                >{{ r.site_name }}</v-chip
                                            >

                                            <br />
                                            <span class="mr-1"
                                                ><b>{{
                                                    r.site_amphur_id
                                                }}</b></span
                                            >
                                            <span
                                                ><b>{{
                                                    r.site_province_id
                                                }}</b></span
                                            >

                                            <div v-if="r.site_address">
                                                <span
                                                    v-if="
                                                        r.site_address.length <
                                                            35
                                                    "
                                                    >{{ r.site_address }}</span
                                                >
                                                <span v-else>
                                                    {{
                                                        r.site_address.substring(
                                                            0,
                                                            35
                                                        ) + "..."
                                                    }}
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            {{ r.case_title }} <br />
                                            <b>{{
                                                r.sub_status_name +
                                                    " - " +
                                                    r.solution
                                            }}</b>
                                            <v-chip
                                                small
                                                class="ml-1 mb-1"
                                                v-if="r.ship_date"
                                                >{{
                                                    "Ship : " +
                                                        r.ship_date +
                                                        " - " +
                                                        r.ship_date_dw
                                                }}
                                            </v-chip>

                                            <div v-if="r.cso.length > 0">
                                                <view-image
                                                    :title="
                                                        'CSO ( ' +
                                                            r.cso.length +
                                                            ' )'
                                                    "
                                                    :data="r.cso"
                                                />
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <p
                                                style="font-size:12px; font-weight: bold; color:#021640;"
                                            >
                                                {{
                                                    "เวลาทำงาน " +
                                                        r.service_time
                                                }}
                                            </p>
                                            <p
                                                style="font-size:12px; font-weight: bold; color:#415378;"
                                                class="mar-t-15"
                                                v-if="r.remark"
                                            >
                                                {{ r.remark }}
                                            </p>
                                            <p
                                                style="font-size:12px; font-weight: bold; "
                                                class="mar-t-15"
                                            >
                                                <span
                                                    style="color:#3F51B5;"
                                                    v-if="r.total_hr == '00'"
                                                    >{{
                                                        "คิดเป็น " +
                                                            r.total_duration +
                                                            " นาที"
                                                    }}</span
                                                >
                                                <span
                                                    style="color:#009688;"
                                                    v-else
                                                    >{{
                                                        "คิดเป็น " +
                                                            r.total_duration +
                                                            " ชั่วโมง"
                                                    }}</span
                                                >
                                            </p>
                                        </td>
                                        <!-- <td class="text-center">
                                            <v-btn
                                                :color="r.btn_color"
                                                x-small
                                                fab
                                                @click="get_MapAllDay(r)"
                                            >
                                                <v-icon :color="r.icon_color">
                                                    mdi-google-maps
                                                </v-icon>
                                            </v-btn>
                                        </td> -->
                                        <td class="text-center">
                                            <v-switch
                                                v-model="checkboxs"
                                                :value="r.subcase_id"
                                                inset
                                                :disabled="
                                                    chk_approve !=
                                                        'not approve' &&
                                                        data_main.approve_status !=
                                                            null
                                                "
                                                @change="change_case()"
                                            ></v-switch>
                                            <!-- @change="calculate(index,i,row.case)" -->
                                        </td>
                                    </tr>
                                    <br />
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-col>
            </v-row>
        </v-card>

        <v-row justify="center">
            <v-dialog
                v-model="dialogMap"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialogMap = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                        <!-- <v-toolbar-title></v-toolbar-title> -->
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <TravelMap :data_map="data_map" />
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>

        <v-row>
            <v-col cols="12" class="text-right">
                <v-btn
                    fab
                    fixed
                    align-self-end
                    bottom
                    small
                    style="z-index:100; margin-bottom: 80px; margin-left: -54px;"
                    @click="dialogLogGuide = true"
                >
                    <v-icon color="primary">mdi-help-circle-outline</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogLogGuide" class="mx-auto" max-width="575">
            <img
                src="../../../assets/all/guide_ot.png"
                alt="guide marker"
                width="100%"
            />
        </v-dialog>

        <v-dialog v-model="dialogLogGuide2" class="mx-auto" max-width="750">
            <img
                src="../../../assets/all/guide_ot2.jpg"
                alt="guide marker"
                width="100%"
            />
        </v-dialog>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>

        <v-dialog v-model="dialogLogOT" width="500">
            <OtLog :emp_id="emp_id" />
        </v-dialog>

        <back-to-top bottom="50px" right="50px">
            <v-btn small fab color="deep-purple lighten-2">
                <v-icon style="color:#FFF">mdi-chevron-up</v-icon>
            </v-btn>
        </back-to-top>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import TravelMap from "./TravelMap2"
import Image from "../../../components/ViewImage2"
import OtLog from "./OTLog"

let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    components: {
        "view-image": Image,
        TravelMap,
        OtLog,
    },
    beforeDestroy() {
        if (typeof window === "undefined") return

        window.removeEventListener("resize", this.onResize, { passive: true })
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.dialogLogGuide2 = true
        this.onResize()
        window.addEventListener("resize", this.onResize, { passive: true })
        this.get_data()
    },
    props: ["data_ScheduleCase"],
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            await axios
                .get(url + "ot", this.tk)
                .then((response) => {
                    // console.log(response.data.approve_status, "--OT")
                    this.data_main = response.data
                    this.showbtn = response.data.showbtn
                    //chk_approve เอาไว้ดักเงื่อนไขเรื่อง save/approve
                    this.chk_approve =
                        response.data.approve_status.requested_status
                    this.text_show = response.data.approve_status.text_show
                    this.checkboxs = response.data.case
                    if (this.chk_approve == "not approve") {
                        this.chk_calculate = true
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        onResize() {
            this.isMobile = window.innerWidth < 600
        },
        get_MapAllDay(data) {
            this.data_map = data
            this.dialogMap = true
        },
        close_approve() {
            this.form_save.remark = ""
            this.menu = false
        },
        async save() {
            let send = {
                case: this.checkboxs,
                remark: this.form_save.remark,
            }
            this.mutateIsLoading()
            await axios
                .post(url + "ot/save-request", send, this.tk)
                .then((response) => {
                    this.mutateIsLoading()
                    this.get_data()
                    this.mutatesnackbar()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        chk_approve_color(st, n, st2) {
            if (n === 1) {
                if (st === "request") {
                    return "yellow darken-1 white--text"
                } else if (st === "head approve" || st2 === "approve") {
                    return "green accent-3 white--text"
                } else if (st2 === "not approve") {
                    return "red accent-2 white--text"
                } else {
                    return "blue-grey darken-2 white--text"
                }
            } else if (n === 2) {
                if (st === "head approve") {
                    return "yellow darken-1 white--text"
                } else if (st === "mgr approve" || st2 === "approve") {
                    return "green accent-3 white--text"
                } else if (st2 === "not approve") {
                    return "red accent-2 white--text"
                } else {
                    return "blue-grey darken-2 white--text"
                }
            } else if (n === 3) {
                if (st === "mgr approve") {
                    return "yellow darken-1 white--text"
                } else if (st === "md approve" || st2 === "approve") {
                    return "green accent-3 white--text"
                } else if (st2 === "not approve") {
                    return "red accent-2 white--text"
                } else {
                    return "blue-grey darken-2 white--text"
                }
            }
        },

        async calculate() {
            this.chk_load = true
            let sendx = {
                checkboxs: this.checkboxs,
            }

            await axios
                .post(url + "ot/calculate", sendx, this.tk)
                .then((response) => {
                    this.chk_load = false
                    this.chk_calculate = true
                    this.$set(this.data_main, "sum", response.data.sum)
                    this.$set(this.data_main, "detail", response.data.detail)
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        change_case() {
            this.chk_calculate = false
        },
    },
    data() {
        return {
            chk_load: false,
            chk_calculate: false,
            tk: null,
            data_main: [],
            team_name: localStorage.team_name,
            isMobile: false,
            checkboxs: [],
            dialogMap: false,
            data_map: [],
            dialogLogGuide: false,
            dialogLogGuide2: false,
            chk_approve: null,
            text_show: "",
            showbtn: null,
            text: "Success, Your work has been saved",
            emp_id: "",
            dialogLogOT: false,
            form_save: {
                remark: "",
            },
            menu: false,
        }
    },
}
</script>
